import React, { useContext, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { setRole, setToken } from '../../../utils/cookies/cookies'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import axiosCommonInstance from '../../../utils/axios/axiosCommonInstance'
import { ProfileContext } from '../../../context/profile'

const Login = () => {
  const navigate = useNavigate()
  const { saveProfile } = useContext(ProfileContext);

  const [showPassword, setShowPassword] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [loading, setLoading] = useState(false)

  const validateForm = () => {
    let valid = true
    if (!email) {
      setEmailError('Email is required')
      valid = false
    } else {
      setEmailError('')
    }

    if (!password) {
      setPasswordError('Password is required')
      valid = false
    } else {
      setPasswordError('')
    }

    return valid
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    // NOTE: This is only when to upload in vercel without backend

    // if (true) {
    //   setToken("test");
    //   setEmailError("");
    //   setPasswordError("");
    //   navigate("/");

    //   return
    // }

    setLoading(true)

    if (validateForm()) {
      axiosCommonInstance
        .post('user/login/mail', {
          email,
          password,
        })
        .then((res) => {
          setToken(res.data?.token)
          setRole(res.data?.role)
          saveProfile(res.data?.user)
          navigate('/')
        })
        .catch((err) => {
          console.log('err :>> ', err)
        }).finally(() => {
          setLoading(false)
        })
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
    setEmailError('')
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
    setPasswordError('')
  }

  // const handleEmailBlur = () => {
  //   if (!email) {
  //     setEmailError("Email is required");
  //   }
  // };

  // const handlePasswordBlur = () => {
  //   if (!password) {
  //     setPasswordError("Password is required");
  //   }
  // };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4">
      <div className="w-full max-w-[400px] mx-auto">
        <div className="flex flex-col items-center gap-6 mb-12">
          <div className="w-32 h-32 border-2 rounded-full border-orange-500   flex items-center justify-center">
            <img src='/WolfLogo.png' className='w-20 h-20' />
          </div>
          <h1 className="text-4xl font-serif">Wolfy</h1>
        </div>
        <div className="w-full">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="block text-lg font-medium leading-6 text-gray-900">Email Address</label>
              <input
                id="email"
                name="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={handleEmailChange}
                className="block p-2 w-full rounded-md border-0 px-4 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-500 outline-none sm:text-sm sm:leading-6"
                placeholder="Your email"
              />
              {emailError && (
                <p className="text-red-600 text-sm">{emailError}</p>
              )}
            </div>
            <div className="space-y-2 relative">
              <label className="block text-lg font-medium leading-6 text-gray-900">Password</label>
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                autoComplete="current-password"
                value={password}
                onChange={handlePasswordChange}
                className="block p-2 w-full rounded-md border-0 px-4 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-500 outline-none sm:text-sm sm:leading-6"
                placeholder="Your password"
              />
              <div
                className="absolute right-3 top-[35px] cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <FiEyeOff className="text-black" />
                ) : (
                  <FiEye className="text-black" />
                )}
              </div>
              {passwordError && (
                <p className="text-red-600 text-sm">{passwordError}</p>
              )}
            </div>
            <div className="text-right">
              <Link
                to="/forgot-password"
                className="text-sm text-orange-500 hover:text-orange-600"
              >
                Forgot password?
              </Link>
            </div>
            <button
              type="submit"
              disabled={!!emailError || !!passwordError || loading}
              className="w-full py-3 px-4 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-medium transition-colors"
            >
              {loading ? (
                <div className="w-5 h-5 mx-auto border-2 border-white border-solid rounded-full loader animate-spin border-t-transparent"></div>
              ) : (
                "Log in"
              )}
            </button>

          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
